import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit } from "@angular/core";

import { ADM0009ServiceService } from "../../../../../Service/ADM0009/adm0009-service.service";
import { WIDGET0004ServiceService } from "../../../../../Service/WIDGET0004/widget0004-service.service";
import { ADM0009Class } from "../../../../../Class/ADM0009/adm0009-class";
import { Ba1300Class } from "../../../../../Class/ba1300/ba1300-class";
import { WIDGET0004Class } from "../../../../../Class/WIDGET0004/widget0004-class";
import { FileAttachmentComponent } from "../../../../pages/Hrms/common/file-attachment/file-attachment.component";
import { FileAttachmentInput } from "../../../../../Class/common/file-attachment/file-attachment-input";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator } from "@angular/material";
import { Router, ActivatedRoute } from "@angular/router";
import { EmployeeListClass } from "../../../../../Class/common/employee-list/employee-list-class";
import { EmployeeListComponent } from "../../../../pages/Hrms/common/employee-list/employee-list.component";
import { FormulaListComponent } from "../../../../pages/Hrms/common/formula_list/formula-list.component";
import { FormulaList } from "../../../../../Class/common/formula-list/formula-list";
import { WIDGET0004NewComponent } from "../../../Hrms/WIDGET0004/New/widget0004-new.component";
import { SubModuleWidgetComponent } from "../sub-module-widget/sub-module-widget.component";
import { WidgetDetailsComponent } from "../widget004-details/widget-details.component";
import { Widget0004Component } from "../widget0004/widget0004.component";
import { GreetingsListComponent } from "../GreetingList/greetings-list.component";
import { Tsk5020Service } from "../../../../../Service/TSK5020/tsk5020.service";
import { Tsk5030Service } from "../../../../../Service/TSK5030/tsk5030.service";
import { data } from "jquery";
import { Tsk5020Class } from "../../../../../Class/TSK5020/tsk5020-class";
import { environment } from "../../../../../../environments/environment";
import * as objectPath from "object-path";
import { LayoutUtilsService, MessageType } from "../../../../../core/_base/crud";
import { LayoutConfigService } from "../../../../../core/_base/layout";
import { Tsk5010Class } from "../../../../../Class/TSK5010/tsk5010-class";
import { Tsk5030Class } from "../../../../../Class/TSK5030/tsk5030-class";
import { Tsk5020NewComponent } from "../../../Hrms/TSK5020/New/tsk5020-new.component";

@Component({
	selector: "kt-landing-page-widget",
	templateUrl: "./landing-page-widget.component.html",
	styleUrls: ["./landing-page-widget.component.scss"],
})
export class LandingPageWidgetComponent implements OnInit,AfterViewInit {
	@ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

	@ViewChild('searchInput', { static: false }) searchInput!: ElementRef<HTMLInputElement>;
	isLoading: boolean = false;
	loaderLogo: string;
	currentDate = new Date();
	currentUser: any = "";

	tblGreetingsDetailsArray: Array<any> = [];
	tblGreetingsDetailsCountArray: Array<any> = [];
	tblAnnouncementDetailsArray: Array<any> = [];
	objFileAttachmentInput = new FileAttachmentInput();
	fieldArrayCount: any[];
	dialogRef: any;
	objEmployeeListClass = new EmployeeListClass();
	objFormulaListClass = new FormulaList();
	EmployeeList: Ba1300Class[];
	// LoadCardlist:any;
	blockview: boolean = true;
	currentUrl: string;
	photofinalURL: string;
	photoURL: string;
	signURL: string;
	// LoadList:any[];
	currentPage = 0; // Current page index
	pageSize: number = 4;
	LoadList: any[];
	LoadCardlist = new MatTableDataSource<Tsk5010Class>();
	TotalListArray = new MatTableDataSource<Tsk5010Class>();
	objAnnouncementDatails = new WIDGET0004Class();
	currentUserID: number;
	pageValue: number;
	TotalLength: number;
	TotalList: any[];
	DisplayList: any[];
	filetervalue: string;
	taskCount: number;
	completedTasks: number;
	progressTasks: number;
	pendingTasks: number;
	TodaysTasks: number;
	Approvelist: any[];
	VerificationPending: number;
	SelfTasks: number;
	FilteredList: any[] = [];
	activeCard: string | null = null;
	MasterList: any[] = [];

	constructor(private changeDetectorRef: ChangeDetectorRef, public dialog: MatDialog, private ADM0009service: ADM0009ServiceService, private TaskCardService: Tsk5020Service, private Tsk5030Service: Tsk5030Service, private WIDGET0004service: WIDGET0004ServiceService, private router: Router, private layoutConfigService: LayoutConfigService) {}

ngOnInit() {
	const loaderConfig = this.layoutConfigService.getConfig("loader");
	this.loaderLogo = objectPath.get(loaderConfig, "logo");
	this.changeDetectorRef.detectChanges();
	this.photoURL = "UploadFiles/DocManager/Default/photo.png";
	this.signURL = "UploadFiles/DocManager/Default/sign.jpg";
	this.currentUser = JSON.parse(localStorage.getItem("currentUser")).EmpNam;
	this.currentUserID = Number(JSON.parse(localStorage.getItem("currentUser")).EmpId);
	this.currentUrl = environment.baseUrl.replace("api/", "");
	this.photofinalURL = "UploadFiles/DocManager/Default/photo.png";
	// this.isLoading=true;
	this.onLoad();
	this.onLoadTaskCard(this.currentUserID);
	this.objEmployeeListClass.EmployeeList = [];
}
ngAfterViewInit(): void {
	// this.setActiveCard('total');
}
AnnouncementDatails(field) {
	this.objAnnouncementDatails.AnnouncementId = field;

	this.dialogRef = this.dialog.open(Widget0004Component, {
		width: "600px",
		height: "300px",
		data: this.objAnnouncementDatails,
	});
	// var url = '/hrms/widget0004-detail';

	// this.router.navigate([url], { queryParams: {'AnnouncementId': field, } });
	// this.changeDetectorRef.detectChanges();
}
ViewGreetingList() {
	this.dialogRef = this.dialog.open(GreetingsListComponent, {
		width: "600px",
		height: "300px",
		data: this.objEmployeeListClass,
	});
}
ViewAnnouncementList() {
	this.dialogRef = this.dialog.open(WidgetDetailsComponent, {
		width: "700px",
		height: "600px",
		data: this.objEmployeeListClass,
	});
}
onLoad() {
	this.ADM0009service.LoadGreetings().subscribe((data) => {
		this.tblGreetingsDetailsArray = data.Ba1300List as Ba1300Class[];
		this.tblGreetingsDetailsCountArray = data.Ba1300ListCount as Ba1300Class[];
		if (this.tblGreetingsDetailsCountArray.length > 6) {
			var VarAnnouncement = <HTMLFormElement>document.getElementById("btnGreetings");
			VarAnnouncement.hidden = false;
		} else {
			var VarAnnouncement = <HTMLFormElement>document.getElementById("btnGreetings");
			VarAnnouncement.hidden = true;
			this.changeDetectorRef.detectChanges();
		}
		this.changeDetectorRef.detectChanges();
	});

	this.WIDGET0004service.LoadAnnouncement().subscribe((data) => {
		this.tblAnnouncementDetailsArray = data.WIDGET0004List;
		this.changeDetectorRef.detectChanges();
	});
	this.WIDGET0004service.GetCountAnnouncement().subscribe((list) => {
	this.fieldArrayCount = list;
	if (this.fieldArrayCount.length > 6) {
		var VarAnnouncement = <HTMLFormElement>document.getElementById("btnAnnouncement");
		VarAnnouncement.hidden = false;
	} else {
		var VarAnnouncement = <HTMLFormElement>document.getElementById("btnAnnouncement");
		VarAnnouncement.hidden = true;
		this.changeDetectorRef.detectChanges();
	}
	});
}
showTotalTasks() {
	this.currentPage = 0;
	this.currentPage = 0;
	this.LoadList = this.MasterList.filter(task =>task && task.FkFieldIdTaskRole != 2);
	this.TotalLength = this.LoadList.length;
	this.updatePaginatedData1();
	this.updatePaginatedDataTable1();
	this.changeDetectorRef.detectChanges();
}
showPendingTasks() {
	this.currentPage = 0;
	this.LoadList = this.TotalList.filter((task) => task && task.TaskStatus.toString() === "0"&&  task.FkFieldIdTaskRole.toString() !== "2");
	this.TotalLength = this.LoadList.length;
	this.updatePaginatedData1();
	this.changeDetectorRef.detectChanges();
}
showProgressTasks() {
	this.currentPage = 0;
	this.LoadList = this.TotalList.filter((task) => task && task.TaskStatus.toString() === "1"&&  task.FkFieldIdTaskRole.toString() !== "2");
	this.TotalLength = this.LoadList.length;
	this.updatePaginatedData1();
	this.updatePaginatedDataTable1();
	this.changeDetectorRef.detectChanges();
}
showCompletedTasks() {
	this.currentPage = 0;
	this.LoadList = this.TotalList.filter((task) => task && task.TaskStatus.toString() === "2"&&  task.FkFieldIdTaskRole.toString() !== "2" );
	this.TotalLength = this.LoadList.length;
	this.updatePaginatedData1();
	this.updatePaginatedDataTable1();
	this.changeDetectorRef.detectChanges();
}
showTodaysTasks() {
	this.currentPage = 0;
	this.LoadList = this.TotalList.filter((task) => task && task.FkFieldIdTaskRole.toString() !== "2");
	this.TotalLength = this.LoadList.length;
	this.updatePaginatedData1();
	this.updatePaginatedDataTable1();
	this.changeDetectorRef.detectChanges();
}
showVerificationPending(landing: string) {
	this.isLoading = true;
	this.router.navigate(["/hrms/Tsk5030-find"], { queryParams: { Pagename: "landing" } });
	this.changeDetectorRef.detectChanges();
}
showSelfTask() {
	this.currentPage = 0;
	this.LoadList = this.MasterList.filter(task => task.FkFieldIdTaskRole == 2); 
	this.TotalLength = this.LoadList.length;
	this.updatePaginatedData1();
	this.updatePaginatedDataTable1();
	this.changeDetectorRef.detectChanges();
}
onLoadTaskCard(EmpId: number) {
	var classobj = new Tsk5020Class();
		this.TaskCardService.LoadCard(classobj).subscribe((data) => {
			this.LoadCardlist = data.LoadCardlist;
			this.LoadList = data.LoadCardlist;
			this.MasterList = data.LoadCardlist;
			this.TotalList = this.MasterList.filter(task =>task && task.FkFieldIdTaskRole.toString() !== "2");           
			this.TotalListArray.data = data.LoadCardlist;
			this.LoadList = this.TotalList.slice(); 
			this.taskCount = this.MasterList.filter(task =>task && task.FkFieldIdTaskRole != 2).length;
			if(this.taskCount){
				this.setTaskCount(this.taskCount);
			}
			this.completedTasks = this.MasterList.filter(task =>task && task.TaskStatus == 2 && task.FkFieldIdTaskRole != 2).length;
			this.progressTasks = this.MasterList.filter(task =>task && task.TaskStatus == 1 && task.FkFieldIdTaskRole != 2).length
			this.pendingTasks = this.MasterList.filter(task =>task && task.TaskStatus == 0 && task.FkFieldIdTaskRole != 2).length;
			this.SelfTasks = this.MasterList.filter(task =>task && task.FkFieldIdTaskRole == 2).length;
			// Get today's date in dd-MMM-yyyy format to match backend format
			const today = new Date();
			const day = today.getDate().toString().padStart(2, "0");
			const month = today.toLocaleDateString("en-US", { month: "short" });
			const year = today.getFullYear();
			const todayFormatted = `${day}-${month}-${year}`;
			this.TodaysTasks = this.MasterList.filter(task =>task && task.StrAssignedonDate === todayFormatted &&task.FkFieldIdTaskRole != 2).length;
			if (this.SelfTasks > 0 && this.taskCount === 0) {
	this.activeCard = 'self';
	this.showSelfTask();
} else {
	this.activeCard = 'total';
	this.showTotalTasks();
}
		});
	this.loadVerificationPendingData();
}
loadVerificationPendingData() {
	var classobj = new Tsk5030Class();
	this.Tsk5030Service.LoadDatas(classobj).subscribe((data) => {
	console.log("Verification API Response:", data); // Debug
	this.Approvelist = data.LoadDatalist;
	this.VerificationPending = this.Approvelist ? this.Approvelist.length : 0;
	console.log("VerificationPending count:", this.VerificationPending); // Debug
	this.changeDetectorRef.detectChanges();
	});
}
AssignButton(landing: string) {
	this.isLoading = true;
	this.router.navigate(["/hrms/Tsk5010-new"], {
		queryParams: { type: "edit", Pagename: "landing" },
		state: { fromLanding: landing === "landing" },
	});
}
VerifyButton(landing: string) {
	this.router.navigate(["/hrms/Tsk5030-find"], {});
}
edit(data: Tsk5020Class, landing: string) {
	// this.isLoading = true;
	// this.router.navigate(["/hrms/Tsk5020-new"], {
	// 	queryParams: { type: "edit", TaskId: data.TaskId, Pagename: "landing" },
	// 	state: { fromLanding: landing === "landing" },
	// });
	 this.dialog.open(Tsk5020NewComponent, {
      width: '70vw',
	  height: '90vh',
	  maxHeight: '90vh',
	 data: {
			details: data,
			flag: false        // 👈 your flag
		}
  });
}
updatePaginatedData1() {
	const startIndex = this.currentPage * this.pageSize;
	const currentData = this.LoadList || [];
	this.DisplayList = currentData.slice(startIndex, startIndex + this.pageSize);
	this.pageValue = currentData.length > this.pageSize ? this.pageSize : currentData.length;
	if (this.DisplayList.length > 0) {
		this.isLoading = false;
	}
	this.changeDetectorRef.detectChanges();
}
updatePaginatedDataTable1() {
	const startIndex = this.currentPage * this.pageSize;
	//   const filteredData = this.applyFilter(this.LoadCardlist.data);
	this.isLoading = false;
	this.changeDetectorRef.detectChanges();
}
onPageChangeEvent(event) {
	this.currentPage = event.pageIndex;
	this.pageSize = event.pageSize;
	this.updatePaginatedData1();
	this.changeDetectorRef.detectChanges();
}
public doFilter = (value: string) => {
	value = value.trim(); // Remove whitespace
	value = value.toLowerCase();
	this.filetervalue = value;
	this.updatePaginatedData(); // Re-apply filter and update data
	this.updatePaginatedDataTable();
	this.changeDetectorRef.detectChanges();
};
updatePaginatedData() {
  const filteredData = this.applyFilter(this.LoadList) || [];

  // update total length first so paginator shows correct total
  this.TotalLength = filteredData.length;

  // compute startIndex based on current paginator state
  let startIndex = (this.currentPage || 0) * (this.pageSize || 1);

  // if the startIndex is beyond the filtered results, reset to first page
  if (startIndex >= filteredData.length && filteredData.length > 0) {
    this.currentPage = 0;
    startIndex = 0;

    // update paginator UI if present
    if (this.paginator) {
      // reset the UI to first page
      this.paginator.firstPage();
      // ensure pageSize is in sync
      this.paginator.pageSize = this.pageSize;
    }
  }

  // pageValue is number of items to show on this page
  this.pageValue = filteredData.length > this.pageSize ? this.pageSize : filteredData.length;

  // slice the data for display
  this.DisplayList = filteredData.slice(startIndex, startIndex + this.pageSize);

  // loading flag
  this.isLoading = this.DisplayList.length === 0 ? true : false;

  // trigger change detection
  this.changeDetectorRef.detectChanges();
}
applyFilter(data: any[]) {
	if (!this.LoadCardlist.filter) {
		return data; // No filter applied, return all data
	}
	const filterValue = this.filetervalue.toLowerCase();
	return data.filter((Task) => (Task.TaskCaption && Task.TaskCaption.toLowerCase().includes(filterValue)) || (Task.TaskNumber && Task.TaskNumber.toLowerCase().includes(filterValue)) || (Task.strTaskStatus && Task.strTaskStatus.toLowerCase().includes(filterValue)) || (Task.PriorityDescription && Task.PriorityDescription.toLowerCase().includes(filterValue)) || (Task.EmployeeNameAssignedTo && Task.EmployeeNameAssignedTo.toLowerCase().includes(filterValue)) || (Task.EmployeeNameAssignedBy && Task.EmployeeNameAssignedBy.toLowerCase().includes(filterValue)) || (Task.StrprojectName && Task.StrprojectName.toLowerCase().includes(filterValue)) || (Task.StrTaskName && Task.StrTaskName.toLowerCase().includes(filterValue)) || (Task.TaskDetailedDescription && Task.TaskDetailedDescription.toLowerCase().includes(filterValue)));
}
updatePaginatedDataTable() {
	const startIndex = this.currentPage * this.pageSize;
	const filteredData = this.applyFilter(this.LoadList);
	// Set `pageValue` to reflect the range of items on the current page
	this.pageValue = filteredData.length > this.pageSize ? this.pageSize : filteredData.length;
	this.TotalLength = filteredData.length;
	this.isLoading = false;
	this.changeDetectorRef.detectChanges();
}
showTodayTasks() {
	this.currentPage = 0;
	const today = new Date();
	const day = today.getDate().toString().padStart(2, "0");
	const month = today.toLocaleDateString("en-US", { month: "short" });
	const year = today.getFullYear();
	const todayFormatted = `${day}-${month}-${year}`;
	this.LoadList = this.TotalList.filter((task) => task && task.StrAssignedonDate === todayFormatted && task.FkFieldIdTaskRole.toString() !== "2");	this.TotalLength = this.LoadList.length;
	this.updatePaginatedData1();
	this.updatePaginatedDataTable1();
}
setActiveCard(cardType: string): void {
	// this.isLoading=true;
	this.activeCard = cardType;
	if (this.searchInput) {
	this.searchInput.nativeElement.focus();
	}
}
setTaskCount(value: number) {
	this.taskCount = value;
	setTimeout(() => {if (this.searchInput) {this.searchInput.nativeElement.focus();}}, 0);
}
}
